export default __webpack_public_path__ + "static/media/2026.70ef410e.png";